var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 25,
    height: 22,
    rx: 3,
    fill: "#20A486"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51652 15V7.245H12.2005C13.0732 7.245 13.8102 7.39533 14.4115 7.696C15.0202 7.99667 15.4785 8.43667 15.7865 9.016C16.1018 9.588 16.2595 10.2883 16.2595 11.117C16.2595 11.9383 16.1018 12.6387 15.7865 13.218C15.4785 13.7973 15.0202 14.241 14.4115 14.549C13.8102 14.8497 13.0732 15 12.2005 15H9.51652ZM10.6605 14.043H12.1345C13.1318 14.043 13.8725 13.801 14.3565 13.317C14.8478 12.833 15.0935 12.0997 15.0935 11.117C15.0935 10.1343 14.8478 9.40467 14.3565 8.928C13.8725 8.444 13.1318 8.202 12.1345 8.202H10.6605V14.043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaily);
export default __webpack_public_path__ + "static/media/daily.a29594a6c04b2e1c5a5f0c61d9c738bd.svg";
export { ForwardRef as ReactComponent };